import { render, staticRenderFns } from "./AcclaimBadge.vue?vue&type=template&id=83176bd4&scoped=true"
import script from "./AcclaimBadge.vue?vue&type=script&lang=js"
export * from "./AcclaimBadge.vue?vue&type=script&lang=js"
import style0 from "./AcclaimBadge.vue?vue&type=style&index=0&id=83176bd4&prod&lang=scss&scoped=true&v-if=false"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83176bd4",
  null
  
)

export default component.exports